
import { computed, defineComponent, PropType, ref, watch } from 'vue'

export default defineComponent({
  props: {
    filters: {
      type: Array as PropType<Filter[]>,
      required: true
    }
  },
  setup (props, context) {
    const keyword = ref<string>('')
    const filtered = computed<Filter[]>(() => {
      if (keyword.value === '') return props.filters

      return props.filters.filter((filter) => {
        return filter.name.includes(keyword.value)
      })
    })

    const check = (filter: Filter) => {
      if (checked.value.includes(filter)) {
        checked.value = checked.value.filter((f) => {
          return f !== filter
        })
      } else {
        checked.value = [...checked.value, filter]
      }
    }

    const checked = ref<Filter[]>([])
    watch(() => checked.value, () => {
      context.emit('check', checked.value)
    })

    const checkbox = ref<boolean>(false)
    watch(() => checkbox.value, (value) => {
      if (value) {
        checked.value = Array.from(new Set([...checked.value, ...filtered.value]))
      } else {
        checked.value = checked.value.filter((c) => {
          return !filtered.value.includes(c)
        })
      }
    })

    return {
      keyword,
      filtered,
      check,
      checkbox,
      checked
    }
  }
})
